// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__Do2Ia","bigColWidth":"Table_bigColWidth__3wXu1","biggerColWidth":"Table_biggerColWidth__Q6Kw4","row":"Table_row__1eRaf","col":"Table_col__1TBz-"};